import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import '../style/ProjectDetails.css';

function ProjectDetails() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        const response = await fetch(`https://leoleveque.net/api/projects/${projectId}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setProject(data);
      } catch (error) {
        console.error('Error fetching project details:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectDetails();
  }, [projectId]);

  if (loading) {
    return <div className="spinner"></div>;
  };

  if (error) {
    return <p>Error loading project details. Please try again later.</p>;
  }

  if (!project) {
    return <p>Project not found.</p>;
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="project-details-container">
      <button className="back-button" onClick={() => navigate('/')}>
        &lt;
      </button>
      <div className="project-details-content">
        <div className="profile-section-detail">
          <img
            src={require('../ressources/pdp.jpg')} 
            alt="Profile of Léo Lévêque"
            className="profile-picture-detail"
          />
          <div className="profile-name-detail">Léo Lévêque</div>
        </div>
        <div className="image-section">
          <Slider {...settings} className="project-carousel">
            {project.images.map((image, index) => (
              <div key={index}>
                <img
                  src={`${image}`} 
                  alt={project.title}
                  className="project-main-image"
                />
              </div>
            ))}
          </Slider>
          <div className="project-title-description">
            <div className="project-title">{project.title}</div>
            <p className="project-description">{project.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetails;
